import React from 'react'
import ReactDOM from 'react-dom'
// import {ConnectedRouter} from 'react-router-redux'
// import ReactGA from 'react-ga'
import * as SentryInstance from '@sentry/react'
import { createStore, applyMiddleware, compose } from 'redux'
import createSagaMiddleware from 'redux-saga'
import { Provider } from 'react-redux'
// import { ApolloProvider } from 'react-apollo'

import rootReducer from './store/reducers'
import rootSaga from './store/sagas'
import * as serviceWorker from './serviceWorker'
import './core/core.scss'
import Router from './router'
// import { trackingId } from './core/variables'
import { TOKEN } from './api-client/constants'
import { getLocalItem } from './local-client/local-client'

const PROD = process.env.REACT_APP_PROD === 'TRUE'

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__: any
    Trustpilot: any
  }
}

SentryInstance.init({
  ignoreErrors: ['Non-Error promise rejection captured'],
  dsn:
    'https://58608893bfe5410cb28d9abee03098b5@o273852.ingest.sentry.io/5402550',
  release: `my-project-name@${process.env.REACT_APP_VERSION}`,
})

const userToken = getLocalItem(TOKEN)
if (userToken) {
  SentryInstance.setUser({ id: userToken })
}
// ReactGA.initialize(trackingId)

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
const sagaMiddleware = createSagaMiddleware()
const enhancer = composeEnhancers(applyMiddleware(sagaMiddleware))

let store
if (PROD) {
  store = createStore(
    // @ts-ignore
    rootReducer,
    applyMiddleware(sagaMiddleware),
  )
} else {
  store = createStore(
    // @ts-ignore
    rootReducer,
    enhancer,
  )
}

sagaMiddleware.run(rootSaga)

// @ts-ignore
ReactDOM.render(
  <Provider store={store}>
    <Router />
  </Provider>,
  document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
